import toast from 'react-hot-toast';
import React, { useState } from 'react';
import { Button } from '@/features/button';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Modal } from '@/features/modal';
import { EXTRA_BOTTOM } from '@/features/toast-container/constant';
import { useNavigateLogin } from '@/app/_utils/session/use-navigate-login';
import useUser from '@/utils/use-user';
import usePostNotifyMe from './buttons/utils/use-post-notify-me';
import usePDPData from '../_utils/use-pdp-data';
interface Props {
  type: 'cta' | 'buy-box';
}
const NotSalable = ({
  type
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    data
  } = usePDPData();
  const {
    isLoggedIn
  } = useUser();
  const {
    mutateAsync: notifyMeRequest,
    isPending
  } = usePostNotifyMe({
    id: data?.id || ''
  });
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigateLogin = useNavigateLogin();
  const notifyMeHandler = async () => {
    if (isLoggedIn) {
      await notifyMeRequest(undefined);
      toast.success('موجود شدن کالا از طریق پیامک به شما اطلاع‌رسانی می‌شود.', {
        duration: 3000,
        id: 'notify-me-toast',
        style: {
          maxWidth: 'max-content',
          bottom: EXTRA_BOTTOM
        }
      });
    } else {
      setShowLoginModal(true);
    }
  };
  const scrollToSimilarsHandler = () => {
    const commentsOffset = document.getElementById('pdp-similars')?.offsetTop;
    if (!commentsOffset) return;
    window.scrollTo({
      behavior: 'smooth',
      top: commentsOffset
    });
  };
  const showTopText = type === 'buy-box' || type === 'cta' && !data?.isSalable;
  return <>
            <div data-test='pdp-not-salable' className='flex w-full flex-col items-center gap-1.5 lg:gap-4'>
                {showTopText && <span className='py-0 text-caption-12 font-medium text-text-darkGray lg:py-7 lg:text-body-14'>
                        این محصول ناموجود است.
                    </span>}

                <Button graphicStyle='filled' size='large' isLoading={isPending} onClick={data?.isSalable ? notifyMeHandler : scrollToSimilarsHandler} className='w-full' data-sentry-element="Button" data-sentry-source-file="not-salable.tsx">
                    {data?.isSalable ? 'موجود شد، خبرم کنید' : 'مشاهده محصولات مشابه'}
                </Button>
            </div>

            <Modal title='اطلاع رسانی' width='w-full lg:w-[508px]' className='bottom-0 h-fit' isOpen={showLoginModal} handleClose={() => {
      setShowLoginModal(false);
    }} data-sentry-element="Modal" data-sentry-source-file="not-salable.tsx">
                <div className='flex flex-col gap-6'>
                    <span className='text-body-14 text-text-black lg:text-body-16'>
                        برای با خبر شدن از موجود شدن کالا، لطفا ابتدا وارد شوید.
                    </span>
                    <Button onClick={() => navigateLogin()} graphicStyle='filled' size={isMobile ? 'medium' : 'large'} className='mx-auto' data-sentry-element="Button" data-sentry-source-file="not-salable.tsx">
                        ورود به حساب کاربری
                    </Button>
                </div>
            </Modal>
        </>;
};
export default NotSalable;